import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import PartnerFileBulkList from './PartnerFileBulkList';
import PartnerFileBulkFilters from './PartnerFileBulkFilters';

function PartnerFileBulkForm({
  partnerFileBulkList,
  filters,
  onFilterChange,
  allPartnersSelected,
  anyPartnerSelected,
  onSelectAllPartners,
  pager,
  setPager,
  totalCount,
  setPartners,
  onCheckBoxChange,
  onAddBulkFile,
  saving
}) {
  return (
    <Grid container gap={3}>
      <Grid item xs={12}>
        <PartnerFileBulkFilters filters={filters} onFilterChange={onFilterChange} saving={saving} />
      </Grid>
      <Grid item xs={12} mt={1}>
        <PartnerFileBulkList
          partnerFileBulkList={partnerFileBulkList}
          allPartnersSelected={allPartnersSelected}
          anyPartnerSelected={anyPartnerSelected}
          onSelectAllPartners={onSelectAllPartners}
          pager={pager}
          setPager={setPager}
          totalCount={totalCount}
          setPartners={setPartners}
          onCheckBoxChange={onCheckBoxChange}
          onAddBulkFile={onAddBulkFile}
          saving={saving}
        />
      </Grid>
    </Grid>
  );
}

PartnerFileBulkForm.propTypes = {
  partnerFileBulkList: PropTypes.array,
  filters: PropTypes.object.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  allPartnersSelected: PropTypes.bool.isRequired,
  anyPartnerSelected: PropTypes.bool.isRequired,
  onSelectAllPartners: PropTypes.func.isRequired,
  pager: PropTypes.number.isRequired,
  setPager: PropTypes.func.isRequired,
  totalCount: PropTypes.number.isRequired,
  setPartners: PropTypes.func.isRequired,
  onCheckBoxChange: PropTypes.func.isRequired,
  onAddBulkFile: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired
};

export default PartnerFileBulkForm;
